import { FunctionComponent } from "react";

export const CpmLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/cpm.png"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="CPM"
    />
  );
};
